module.exports = __webpack_public_path__ + "static/media/ChevronLeft.eab9e6e1.svg";